import { AnalyticsService } from "@app/util/analytic/AnalyticsService";

const dealTableAnalytics = new AnalyticsService("Deal Table");

export const dealListViewAnalytics = new AnalyticsService("Deal List View");

export const dealKanbanViewAnalytics = new AnalyticsService("Deal Kanban View");

export const dealForecastViewAnalytics = new AnalyticsService("Deal Forcast View");

export default dealTableAnalytics;
